import axios from 'axios';
import { get } from 'lodash';
import { msgError as msgErrorFunc, msgLocalError } from './errorHandler';

export default async (
  setLoading,
  promise,
  { timeout, translate, msgError = !!translate, noShowCatch = false } = {},
) => {
  let timeoutFunc;
  if (timeout) {
    timeoutFunc = setTimeout(() => setLoading(true), timeout);
  } else {
    setLoading(true);
  }
  let resp;
  try {
    let forAwait = promise;
    if (typeof forAwait === 'function') {
      forAwait = promise();
    }
    resp = await forAwait;
  } catch (e) {
    console.error(e);
    if (!noShowCatch && !axios.isCancel(e)) {
      if (translate) {
        msgLocalError({ error: e, translate });
      } else if (msgError) {
        msgErrorFunc(e);
      }
    }
    throw e;
  } finally {
    timeoutFunc && clearTimeout(timeoutFunc);
    setLoading(false);
  }
  return get(resp, 'data');
};
